// src/app/_components/manage-spaces/manage-spaces.component.ts
// tasks/space_ux.md — "Manage Spaces": a routed page (Manage → Manage Spaces, before Manage Tags)
// replacing the old Home "User" menu → "Spaces" dialog. Its content is entirely
// <app-space-picker> (list all Spaces with name/type/owner/role, switch the active one, edit a
// SHARED Space you own/admin via /space-admin/:id, create a new SHARED Space) — this component is
// just the page shell (header + back-to-Manage button), matching ManageAttachmentsComponent's
// existing page-shell convention.

import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { SpacePickerComponent } from '../space-picker/space-picker.component';

@Component({
  selector: 'app-manage-spaces',
  standalone: true,
  imports: [SpacePickerComponent],
  templateUrl: './manage-spaces.component.html',
})
export class ManageSpacesComponent {
  constructor(private readonly router: Router) {}

  back(): void {
    this.router.navigate(['/manage']);
  }
}
